<template>
	<div>
		<preloader v-if="loading"></preloader>
		<div class="mb-2 px-3 pt-3">
			<h5 class="mb-0">Pre Requisitos</h5>
			<div class="progress" style="height: 10px;">
		 		<div :class="{'progress-bar progress-bar-striped progress-bar-animated':true, 'bg-success':porcentajeLLenos>=100, 'bg-warning':(porcentajeLLenos<100 && porcentajeLLenos>=50), 'bg-danger':porcentajeLLenos<50}" role="progressbar" :style="'width: '+porcentajeLLenos+'%'" :aria-valuenow="porcentajeLLenos" aria-valuemin="0" aria-valuemax="100">{{porcentajeLLenos}}%</div>
			</div>
			<input ref="file" class="d-none" type="file" v-on:change="onFileChange">
		</div>

		<div class="mb-2 px-3" v-if="!loading">
			<ul class="list-group">
				<li v-bind:class="{'list-group-item':true, 'list-group-item-success':(item.LLENO==1 && item.PATH_URL)}" v-for="item in items">
					<div class="d-flex justify-content-between align-items-center mb-2">
						<a :href="url+item.CODIGO+'/download'" v-if="item.PATH_URL" target="_blank">
							<i class="material-icons">cloud_download</i>
							<span v-if="(typeof item.prerequisito.tipo_requisito.DESCRIPCION_PREREQUISITO !== 'undefined')">
								<del v-if="item.LLENO==1">
									{{item.prerequisito.tipo_requisito.DESCRIPCION_PREREQUISITO || ''}}
								</del>
								<span v-else>
									{{item.prerequisito.tipo_requisito.DESCRIPCION_PREREQUISITO || ''}}
								</span>
							</span>
							<span v-else>
								No definido
							</span>
						</a>
						<span v-else>
							<span v-if="(typeof item.prerequisito.tipo_requisito.DESCRIPCION_PREREQUISITO !== 'undefined')">
								<del v-if="item.LLENO==1">
									{{item.prerequisito.tipo_requisito.DESCRIPCION_PREREQUISITO || ''}}
								</del>
								<span v-else>
									{{item.prerequisito.tipo_requisito.DESCRIPCION_PREREQUISITO || ''}}
								</span>
							</span>
							<span v-else>
								No definido
							</span>
						</span>

						<div class="custom-control custom-checkbox">
							<input type="checkbox" class="custom-control-input" :id="'customCheck'+item.CODIGO" v-model="item.LLENO" v-on:click.prevent="lleno(item.CODIGO)" :disabled="disabledVal">
							<label class="custom-control-label" :for="'customCheck'+item.CODIGO">&nbsp</label>
						</div>
					</div>
					<div class="d-flex justify-content-between align-items-center" v-if="item.LLENO!=1 && !disabledVal">
						<a href="#" class="btn btn-light btn-sm" v-on:click.prevent="loadFile(item.CODIGO)">
							<i class="material-icons text-muted">cloud_upload</i>
							Subir Archivo
						</a>
					</div>
					<div class="progress" style="height: 10px; display: none;" :ref="'uploadFile'+item.CODIGO">
				 		<div 
				 		class="progress-bar progress-bar-striped progress-bar-animated bg-success" 
				 		:ref="'uploadFileChild'+item.CODIGO"
				 		role="progressbar" 
				 		style="width: 0%" 
				 		aria-valuenow="0" 
				 		aria-valuemin="0" 
				 		aria-valuemax="100"
				 		duration-duration="10"></div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
	export default {
		props: ['oportunidad', 'disabled'],

		data(){
			return {
				items: [],
				loading: false,
				url: '',
				form: {
					id: '',
					file: ''
				},
			}
		},

		mounted() {
			this.get()

			this.url = crm.url+'/api/oportunidades/prerequisitos/'
		},

		methods: {
			get: function(){
				this.loading = true;
				var url = 'api/oportunidades/'+this.oportunidad+'/prerequisitos';

				axios.get(url)
				.then(response => {
					this.items = response.data;
					for (var i = this.items.length - 1; i >= 0; i--) {
						this.items[i].LLENO = parseInt(this.items[i].LLENO || 0)
					}
				}).catch(error => {
					console.log(error.response);
				}).then(()=>{
					this.loading = false
				});
			},

			lleno: function(codigo){
				var url = 'api/oportunidades/prerequisitos/'+codigo+'/markAsLleno';

				axios.post(url)
				.then(response => {
					this.$toasted.show('Requisito actualizado.');
					const index = this.items.findIndex(x => x.CODIGO == codigo)
					this.items[index].LLENO = response.data.LLENO
				}).catch(error => {
					this.$toasted.show('Error al actualizar.');
					console.log(error.response);
				});
			},

			loadFile(id){
				this.form.id = id
				this.$refs.file.click();
			},

			onFileChange() {
		    	//var file = e.target.files || e.dataTransfer.files;
		    	this.form.file = this.$refs.file.files[0];
		    	
		    	if (!this.form.file)
		    		return;
		    	this.uploadFile();
		    },

			uploadFile: function(){
				this.$refs['uploadFile'+this.form.id][0].style.display = "block"
				this.$refs['uploadFileChild'+this.form.id][0].style.width = "0%"

				var $module = this;
				let formData = new FormData();
	            formData.append('file', this.form.file);

				var url = '/api/oportunidades/prerequisitos/'+this.form.id

				const config = {
				    onUploadProgress: function(progressEvent) {
				      var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
				      console.log(percentCompleted)
				      $module.$refs['uploadFileChild'+$module.form.id][0].style.width = percentCompleted+'%'
				    },
				    headers: {
                    	'Content-Type': 'multipart/form-data'
                	}
				}

				axios.post(url, formData, config)
				.then(function(response){
	        		$module.$toasted.show('El archivo ha sido subido.');
	        		
	        		const ind = $module.items.findIndex(x => x.CODIGO == $module.form.id)

					$module.items[ind].LLENO = response.data.LLENO
					$module.items[ind].PATH_URL = response.data.PATH_URL
	        	})
	        	.catch(function(error){
	        		console.log(error)
	        		console.log(error.response);
	        		$module.$toasted.show('Error al subir archivo.');
	        	}).then(()=>{
	        		$module.$refs['uploadFile'+$module.form.id][0].style.display = "none"
	        	})
			},
		},

		computed: {
			itemsLlenos: function(){
				return this.items.filter(x => x.LLENO == 1).length
			},

			porcentajeLLenos: function(){
				if (this.items.length == 0) {
					return 0
				}
				
				if (this.itemsLlenos == this.items.length) {
					return 100
				}

				return parseFloat(((this.itemsLlenos * 100) / this.items.length) || 0).toFixed(2);
			},

			disabledVal(){
				return (this.disabled != null) ? true : false
			}
		}
	}
</script>